import React from 'react';
import { L } from '../router/Router';
import { C, F } from '../constants';
import { useTheme } from '../contexts/ThemeContext';

export const Footer = () => {
  const { theme } = useTheme();
  
  const footerStyle = {
    background: theme === 'dark' ? C.black : '#FFFFFF',
    borderTop: `1px solid ${theme === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
    padding: '80px 24px 24px',
    color: theme === 'dark' ? C.white : C.black
  };

  const linkStyle = {
    color: theme === 'dark' ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
    textDecoration: 'none',
    fontSize: '14px',
    transition: 'color 0.2s ease',
    display: 'block',
    marginBottom: '12px'
  };

  const sectionStyle = {
    marginBottom: '40px'
  };

  const titleStyle = {
    fontFamily: F,
    fontSize: '12px',
    fontWeight: 700,
    letterSpacing: '0.12em',
    marginBottom: '20px',
    color: C.secondary
  };

  return (
    <footer style={footerStyle} data-testid="footer">
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>

        {/* Logo above grid */}
        <div style={{ marginBottom: '40px' }}>
          <img 
            src={theme === 'dark' ? '/logo-full-dark.svg' : '/logo-full-light.svg'}
            alt="DecX AI"
            style={{
              height: '130px',
              width: 'auto',
              objectFit: 'contain',
              minWidth: '120px'
            }}
          />
        </div>

        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
            gap: '32px',
            marginBottom: '60px',
            alignItems: 'start'
          }}
        >
          {/* Tagline + Contact */}
          <div style={sectionStyle}>
            <p className="font-[Manrope]" style={{ fontSize: '14px', lineHeight: 1.6, opacity: 0.7, maxWidth: '280px', marginBottom: '20px' }}>
              Transform Your Deck to DecX. The power that drives closure.
            </p>
            <div style={{ fontSize: '13px', opacity: 0.6 }}>
              <div style={{ marginBottom: '8px' }}>win@decx.ai</div>
              <div style={{ marginBottom: '8px' }}>+91 9987646054</div>
            </div>
          </div>

          {/* INTELLIGENCE column */}
          <div style={sectionStyle}>
            <div style={titleStyle}>INTELLIGENCE</div>
            <L to="/pitch-deck-intelligence" style={linkStyle}>Pitch Deck Intelligence</L>
            <L to="/sales-deck-intelligence" style={linkStyle}>Sales Deck Intelligence</L>
            <L to="/product-deck-intelligence" style={linkStyle}>Product Deck Intelligence</L>
          </div>

          {/* SOLUTIONS column */}
          <div style={sectionStyle}>
            <div style={titleStyle}>SOLUTIONS</div>
            <L to="/close-round" style={linkStyle}>Close Your Round</L>
            <L to="/close-deals" style={linkStyle}>Close More Deals</L>
            <L to="/win-approval" style={linkStyle}>Win Approval</L>
          </div>

          {/* USE CASES column */}
          <div style={sectionStyle}>
            <div style={titleStyle}>USE CASES</div>
            <L to="/for-founders" style={linkStyle}>For Founders</L>
            <L to="/for-sales-teams" style={linkStyle}>For Sales Teams</L>
            <L to="/for-product-managers" style={linkStyle}>For Product Managers</L>
            <L to="/for-accelerators" style={linkStyle}>For Accelerators</L>
          </div>

          {/* PLATFORM column */}
          <div style={sectionStyle}>
            <div style={titleStyle}>PLATFORM</div>
            <L to="/score" style={linkStyle}>Free DecX Score</L>
            <L to="/pricing" style={linkStyle}>Pricing</L>
            <L to="/slidr" style={linkStyle}>Slidr DFY</L>
          </div>

          {/* COMPANY column */}
          <div style={sectionStyle}>
            <div style={titleStyle}>COMPANY</div>
            <L to="/about" style={linkStyle}>About</L>
            <L to="/contact" style={linkStyle}>Contact</L>
            <L to="/blog" style={linkStyle}>Blog</L>
            <L to="/privacy" style={linkStyle}>Privacy</L>
            <L to="/terms" style={linkStyle}>Terms</L>
          </div>
        </div>

        <div
          style={{
            paddingTop: '24px',
            borderTop: `1px solid ${theme === 'dark' ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: '20px'
          }}
        >
          <p className="font-[Manrope]" style={{ fontSize: '13px', opacity: 0.6 }}>
            2025 Decks N Dollars LLP. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: '24px' }}>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" style={{ ...linkStyle, marginBottom: 0 }}>LinkedIn</a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" style={{ ...linkStyle, marginBottom: 0 }}>Twitter/X</a>
          </div>
        </div>
      </div>
    </footer>
  );
};